import { render, staticRenderFns } from "./FormBuilderColumn.vue?vue&type=template&id=d8a21198&scoped=true&"
import script from "./FormBuilderColumn.vue?vue&type=script&lang=js&"
export * from "./FormBuilderColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a21198",
  null
  
)

export default component.exports